// @flow

import classNames from 'classnames';
import React from 'react';
import type { Node } from 'react';
import { Paragraph } from '@riseart/common';
import { Section, Wrapper, SectionContent } from '@riseart/layout';

import {
  artistActionSectionCls,
  artistActionSectionBorderCls,
  artistActionSectionContentCls,
} from 'shared_components/artist/sections/action/Section.less';

type Props = {
  title: Node,
  subtitle: Node,
  children: Node,
  hideBorder?: boolean,
  background?: ?string,
  disableHeadingTags?: boolean,
};

/**
 * ArtistActionSection
 *
 * @param {Props} props
 */
export const ArtistActionSection = ({
  title,
  subtitle,
  children,
  hideBorder = false,
  background = null,
  disableHeadingTags = false,
}: Props) => (
  <Section
    className={classNames(
      artistActionSectionCls,
      !background && !hideBorder && artistActionSectionBorderCls,
    )}
    background={background}
  >
    <Wrapper>
      <SectionContent
        title={title}
        headingProps={{ tag: disableHeadingTags ? 'span' : 'h2', align: 'center' }}
      >
        <Paragraph align="center">{subtitle}</Paragraph>
        <div className={artistActionSectionContentCls}>{children}</div>
      </SectionContent>
    </Wrapper>
  </Section>
);
